import { ChangeEvent, FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Switch } from '@beeline/design-system-react/extracted-styles';

import { getIsDesktop } from 'src/store/agent/selectors';
import { bookingsActions } from 'src/store/bookings/slice';
import { BookingsPageMode } from 'src/store/bookings/types';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { useMyBookingsPageMode } from './MyBookingsPageModeProvider';
import classes from './MyBookingsPageModeSwitcher.module.scss';

export const MyBookingsPageModeSwitcher: FC = () => {
  const isDesktop = useSelector(getIsDesktop);
  const dispatch = useAppDispatch();
  const { mode, setMode } = useMyBookingsPageMode();

  const changeMode = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setMode(
        event.target.checked
          ? BookingsPageMode.History
          : BookingsPageMode.Actual,
      );
    },
    [setMode],
  );

  useEffect(() => {
    dispatch(bookingsActions.setMode(mode));
  }, [dispatch, mode]);

  return (
    <div className={classes.container}>
      <Switch
        label={isDesktop ? 'Показать историю' : 'История'}
        checked={mode === BookingsPageMode.History}
        onChange={changeMode}
        data-testid='showHistory'
      />
    </div>
  );
};
